import React, { useState } from 'react';
import bgImage from '../assets/homebg1003.jpg';
import Footer from './Footer';
import DomesticTours from './DomesticTours';
import InternationalTours from './InternationalTours';
import AboutUs from './AboutUs';
import Gallery from './Gallery';
import Testimonials from './Testimonials';
import ContactUs from './ContactUs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Home = () => {
  const [showNumber, setShowNumber] = useState(false);

  const toggleNumber = () => setShowNumber(!showNumber);
  
  const openWhatsApp = () => {
    const phoneNumber = '919697988891';
    const message = 'Hello! I am interested in your tour packages. Please provide more information.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800&display=swap');

        /* Hero Section */
        .hero-section {
          background-image: url(${bgImage});
          background-size: cover;
          background-position: center 65%; /* Shift background downward */
          background-repeat: no-repeat;
          color: #fff;
          display: flex;
          align-items: center; /* Center content vertically */
          justify-content: center;
          min-height: clamp(80vh, 100vh, 110vh); /* Increased height for better visibility */
          position: relative;
          padding: clamp(40px, 8vw, 60px) clamp(20px, 5vw, 40px);
          margin-bottom: clamp(30px, 5vw, 40px);
          width: 100%;
          overflow: hidden;
          transform: translateY(-80px);
          // background-attachment: fixed; /* Fixed for parallax effect, fallback to scroll if unsupported */
        }

        .hero-content {
          position: relative;
          z-index: 2;
          max-width: clamp(80%, 85%, 1000px);
          width: 100%;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          // transform: translateY(40px); /* Shift content downward */
          animation: fadeIn 1.2s ease-out;
          font-family: 'Poppins', sans-serif;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(60px); }
          to { opacity: 1; transform: translateY(40px); }
        }

        .hero-heading {
          font-family: 'Poppins', sans-serif;
          font-weight: 800;
          line-height: 1.15;
          text-shadow: 0 4px 12px rgba(0, 0, 0, 0.8);
          margin-bottom: clamp(12px, 2.5vw, 16px);
          color: #ffffff;
          width: 100%;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }

        .hero-heading:first-child {
          font-size: clamp(2rem, 6vw, 4.5rem);
          background: linear-gradient(90deg, #ff8c00, #ff2d55);
          -webkit-background-clip: text;
        background-clip: text;
          // -webkit-text-fill-color: transparent;
        }

        .hero-subheading {
          font-family: 'Poppins', sans-serif;
          font-size: clamp(1.2rem, 3.5vw, 2rem);
          font-weight: 600;
          color: #f0f4ff;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7);
          margin-bottom: clamp(12px, 2.5vw, 16px);
        }

        .hero-main-offer {
          font-family: 'Poppins', sans-serif;
          font-size: clamp(1.6rem, 5vw, 3rem);
          font-weight: 700;
          color: #ffffff;
          text-shadow: 0 3px 10px rgba(0, 0, 0, 0.7);
          margin-bottom: clamp(12px, 2.5vw, 16px);
          line-height: 1.2;
        }

        .hero-tagline {
          font-family: 'Poppins', sans-serif;
          font-size: clamp(1rem, 3vw, 1.8rem);
          font-weight: 500;
          color: #e0f7ff;
          text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
          margin-bottom: clamp(25px, 5vw, 35px);
          line-height: 1.4;
          max-width: 90%;
        }

        .cta-buttons {
          display: flex;
          gap: clamp(12px, 2.5vw, 16px);
          flex-wrap: wrap;
          justify-content: center;
          margin-top: clamp(25px, 5vw, 35px);
          animation: fadeInUp 1.4s ease;
          width: 100%;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .primary-btn {
          background: linear-gradient(135deg, #ff8c00, #ff2d55);
          color: white;
          padding: clamp(12px, 2.8vw, 16px) clamp(24px, 5vw, 34px);
          border-radius: 50px;
          font-family: 'Poppins', sans-serif;
          font-size: clamp(1rem, 2.8vw, 1.3rem);
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 5px 18px rgba(255, 45, 85, 0.5);
          white-space: nowrap;
          text-align: center;
        }

        .primary-btn:hover {
          background: linear-gradient(135deg, #ff2d55, #ff8c00);
          transform: translateY(-4px) scale(1.06);
          box-shadow: 0 8px 22px rgba(255, 45, 85, 0.6);
        }

        .secondary-btn {
          background: transparent;
          color: white;
          padding: clamp(12px, 2.8vw, 16px) clamp(24px, 5vw, 34px);
          border: 2px solid #fff;
          border-radius: 50px;
          font-family: 'Poppins', sans-serif;
          font-size: clamp(1rem, 2.8vw, 1.3rem);
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
          backdrop-filter: blur(8px);
          white-space: nowrap;
          text-align: center;
        }

        .secondary-btn:hover {
          background: rgba(255, 255, 255, 0.25);
          transform: translateY(-4px) scale(1.06);
          box-shadow: 0 6px 18px rgba(255, 255, 255, 0.4);
        }

        /* WhatsApp Floating Button Styles */
        .floating-whatsapp-container {
          position: fixed;
          right: clamp(15px, 4vw, 28px);
          bottom: clamp(15px, 4vw, 28px);
          z-index: 1000;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 12px;
        }

        .whatsapp-button {
          width: clamp(52px, 12vw, 64px);
          height: clamp(52px, 12vw, 64px);
          border-radius: 50%;
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 5px 18px rgba(37, 211, 102, 0.5);
          transition: all 0.3s ease;
          border: none;
          position: relative;
          overflow: hidden;
        }

        .whatsapp-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, #128C7E 0%, #25D366 100%);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .whatsapp-button:hover::before {
          opacity: 1;
        }

        .whatsapp-button:hover {
          transform: scale(1.12);
          box-shadow: 0 8px 22px rgba(37, 211, 102, 0.7);
        }

        .whatsapp-button .icon {
          font-size: clamp(22px, 6vw, 30px);
          position: relative;
          z-index: 1;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.15); }
          100% { transform: scale(1); }
        }

        .whatsapp-number-display {
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: white;
          padding: clamp(10px, 2.5vw, 14px) clamp(18px, 3.5vw, 22px);
          border-radius: 25px;
          font-family: 'Poppins', sans-serif;
          font-weight: 600;
          box-shadow: 0 4px 14px rgba(37, 211, 102, 0.4);
          opacity: ${showNumber ? '1' : '0'};
          transform: translateY(${showNumber ? '0' : '12px'});
          transition: all 0.3s ease;
          pointer-events: ${showNumber ? 'auto' : 'none'};
          font-size: clamp(14px, 3.5vw, 16px);
          white-space: nowrap;
          border: 2px solid rgba(255, 255, 255, 0.25);
          backdrop-filter: blur(10px);
        }

        /* Section Styling */
        .section {
          padding: clamp(25px, 6vw, 40px);
          position: relative;
        }

        .section:nth-child(even) {
          background-color: #f7f9fc;
        }

        .section-title {
          text-align: center;
          font-family: 'Poppins', sans-serif;
          font-size: clamp(1.8rem, 5vw, 2.5rem);
          color: #2a2e7a;
          margin-bottom: clamp(35px, 7vw, 55px);
          position: relative;
          line-height: 1.3;
          padding: 0 10px;
        }

        .section-title:after {
          content: '';
          display: block;
          width: clamp(70px, 16vw, 90px);
          height: 4px;
          background: linear-gradient(to right, #ff8c00, #ff2d55);
          margin: 14px auto 0;
          border-radius: 2px;
        }

        /* Responsive Breakpoints */
        @media (max-width: 1024px) {
          .hero-section {
            min-height: 85vh;
            padding: clamp(30px, 6vw, 50px) clamp(15px, 4vw, 30px);
            background-position: center 65%;
          }

          .hero-content {
            max-width: 90%;
            transform: translateY(30px);
          }

          .hero-heading:first-child {
            font-size: clamp(1.8rem, 5.5vw, 4rem);
          }

          .hero-subheading {
            font-size: clamp(1.1rem, 3.2vw, 1.8rem);
          }

          .hero-main-offer {
            font-size: clamp(1.4rem, 4.5vw, 2.5rem);
          }

          .hero-tagline {
            font-size: clamp(0.9rem, 2.8vw, 1.6rem);
          }

          .cta-buttons {
            gap: clamp(10px, 2vw, 14px);
            margin-top: clamp(20px, 4.5vw, 30px);
          }

          .primary-btn, .secondary-btn {
            padding: clamp(10px, 2.5vw, 14px) clamp(20px, 4.5vw, 30px);
            font-size: clamp(0.9rem, 2.5vw, 1.2rem);
          }

          .section-title {
            font-size: clamp(1.6rem, 4.5vw, 2.2rem);
          }
        }

        @media (max-width: 768px) {
          .hero-section {
            min-height: 75vh;
            padding: clamp(25px, 5vw, 40px) clamp(12px, 3vw, 20px);
            background-position: center 70%;
            background-attachment: scroll; /* Disable fixed background for mobile */
          }

          .hero-content {
            max-width: 95%;
            transform: translateY(20px);
          }

          .hero-heading:first-child {
            font-size: clamp(1.6rem, 5vw, 3.5rem);
          }

          .hero-subheading {
            font-size: clamp(1rem, 3vw, 1.6rem);
          }

          .hero-main-offer {
            font-size: clamp(1.2rem, 4vw, 2.2rem);
          }

          .hero-tagline {
            font-size: clamp(0.85rem, 2.5vw, 1.4rem);
            max-width: 95%;
          }

          .cta-buttons {
            gap: clamp(8px, 1.8vw, 12px);
            margin-top: clamp(15px, 4vw, 25px);
            flex-direction: column;
            align-items: center;
          }

          .primary-btn, .secondary-btn {
            padding: clamp(10px, 2.2vw, 12px) clamp(18px, 4vw, 26px);
            font-size: clamp(0.85rem, 2.2vw, 1.1rem);
            width: clamp(160px, 50vw, 200px);
          }

          .section-title {
            font-size: clamp(1.4rem, 4vw, 2rem);
          }
        }

        @media (max-width: 480px) {
          .hero-section {
            min-height: 70vh;
            padding: clamp(20px, 4vw, 30px) clamp(10px, 2.5vw, 15px);
            background-position: center 75%;
          }

          .hero-content {
            max-width: 98%;
            transform: translateY(15px);
          }

          .hero-heading:first-child {
            font-size: clamp(1.4rem, 4.5vw, 3rem);
          }

          .hero-subheading {
            font-size: clamp(0.9rem, 2.8vw, 1.4rem);
          }

          .hero-main-offer {
            font-size: clamp(1.1rem, 3.5vw, 1.8rem);
            line-height: 1.3;
          }

          .hero-tagline {
            font-size: clamp(0.8rem, 2.5vw, 1.2rem);
            max-width: 100%;
          }

          .cta-buttons {
            gap: clamp(6px, 1.5vw, 10px);
            margin-top: clamp(12px, 3vw, 20px);
          }

          .primary-btn, .secondary-btn {
            padding: clamp(8px, 2vw, 10px) clamp(16px, 3.5vw, 22px);
            font-size: clamp(0.8rem, 2vw, 1rem);
            width: clamp(140px, 45vw, 180px);
          }

          .section-title {
            font-size: clamp(1.2rem, 3.5vw, 1.6rem);
          }
        }

        @media (max-width: 350px) {
          .hero-section {
            min-height: 65vh;
            padding: clamp(15px, 3vw, 20px) clamp(8px, 2vw, 12px);
            background-position: center 80%;
          }

          .hero-content {
            max-width: 100%;
            transform: translateY(10px);
          }

          .hero-heading:first-child {
            font-size: clamp(1.2rem, 4vw, 2.5rem);
          }

          .hero-subheading {
            font-size: clamp(0.8rem, 2.5vw, 1.2rem);
          }

          .hero-main-offer {
            font-size: clamp(1rem, 3.2vw, 1.5rem);
          }

          .hero-tagline {
            font-size: clamp(0.75rem, 2.2vw, 1rem);
          }

          .cta-buttons {
            gap: clamp(5px, 1.2vw, 8px);
            margin-top: clamp(10px, 2.5vw, 15px);
          }

          .primary-btn, .secondary-btn {
            padding: clamp(7px, 1.8vw, 9px) clamp(14px, 3vw, 20px);
            font-size: clamp(0.75rem, 1.8vw, 0.9rem);
            width: clamp(120px, 40vw, 160px);
          }

          .section-title {
            font-size: clamp(1.1rem, 3.2vw, 1.4rem);
          }
        }
      `}</style>

      {/* Floating WhatsApp Button */}
      <div className="floating-whatsapp-container">
        {showNumber && (
          <div className="whatsapp-number-display">
            +91 9697988894
          </div>
        )}
        <button 
          className="whatsapp-button" 
          onClick={openWhatsApp}
          onMouseEnter={toggleNumber}
          onMouseLeave={toggleNumber}
          title="Chat with us on WhatsApp"
        >
          <FontAwesomeIcon icon={faWhatsapp} className="icon" />
        </button>
      </div>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-heading">
            NMT INDIA HOLIDAYS<sup>®</sup>
          </h1>
          <h2 className="hero-subheading">
            PRESENTS
          </h2>
          <h2 className="hero-main-offer">
            TRAVEL WITH EDUCATION
          </h2>
          {/* <h3 className="hero-tagline">
            Powerful Learning Experiences Beyond The Classroom
          </h3> */}
          <div className="cta-buttons">
            <a href="/domestic-tours" className="primary-btn">
              Explore Tours
            </a>
            <a href="/contact-us" className="secondary-btn">
              Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* Other Sections */}
      <section className="section">
        <h2 className="section-title">Domestic Tours</h2>
        <DomesticTours />
      </section>

      <section className="section">
        <h2 className="section-title">International Tours</h2>
        <InternationalTours />
      </section>

      <section className="section">
        <AboutUs />
      </section>

      <section className="section">
        <Gallery />
      </section>

      <section className="section">
        <Testimonials />
      </section>

      <section className="section">
        <ContactUs />
      </section>

      <Footer />
    </>
  );
};

export default Home;